<template>
  <div>
    <span v-if="header === 'actions'">
      <pcg-checkbox  v-if="noRegister == 0 && multiOperations" variant="normal" class="multi-checkboxes" v-model="publicationCheckbox" @input="changeStatus"></pcg-checkbox>
      <pcg-options class="action-btn" :options="pcgOptions" v-if="pcgOptions.length > 0" :text="$t('components.publication_element.actions')" />
      <pcg-comments-modal
        date-type="long"
        :current-user="currentUser"
        :comments="allComments"
        editCommentPopoverText="Edytuj komentarz"
        :modal-id="achievement.id + '-allCommentsModal'"
        v-on:commentWasAdded="commentAdded"
        :adding-comments-enabled="hasRight('add_comments')"
        :comments-list-enabled="hasRight('edit_comment') || hasRight('edit_own_comment')"
      />
      <pcg-modal
        v-if="hasRight('view_history')"
        size="lg"
        scrollable
        :modalId="achievement.id + '-historyModal'"
        :title="$t('views.publications.history.title')"
        icon="pcg-icon-comment"
        btnTitle="OK"
        :action="closeHistory"
      >
        <publication-history :publication="achievement" :history="history" :scope="scope" @get-history="getHistory"/>
      </pcg-modal>
      <b-modal ref="archivePublicationConfirm"
               :hide-header="true"
               footer-class="my-modal-footer"
               :centered="true"
               v-bind:ok-title="$t('general.confirm')"
               ok-variant="primary"
               :no-close-on-esc="true"
               @ok="archivePublication"
               v-bind:cancel-title="$t('general.cancel')"
               cancel-variant="default"
               content-class="my-modal-content"
      >
        <div class="confirm-header">{{ $t('components.publication_element.archiving') }}</div>
        <div class="confirm-text">{{ $t('components.publication_element.archiving_confirmation') }}</div>
      </b-modal>
      <b-modal ref="restorePublicationConfirm"
               :hide-header="true"
               footer-class="my-modal-footer"
               :centered="true"
               v-bind:ok-title="$t('general.confirm')"
               ok-variant="primary"
               :no-close-on-esc="true"
               @ok="restorePublication"
               v-bind:cancel-title="$t('general.cancel')"
               cancel-variant="default"
               content-class="my-modal-content"
            >
        <div class="confirm-header">{{ $t('components.publication_element.restoring') }}</div>
        <div class="confirm-text">{{ $t('components.publication_element.restoring_confirmation') }}</div>
      </b-modal>
    </span>
    <span v-else-if="header === 'achievement_title'" class="long-text">{{ achievement.title }}</span>
    <span v-else-if="header === 'achievement_title_en'" class="long-text">{{ achievement_title_en }}</span>
    <span v-else-if="header === 'achievement_type'">{{ $t(publicationType) }}</span>
    <span v-else-if="header === 'achievement_year'">{{ achievement.year }}</span>
    <span v-else-if="header === 'another_contest_name'">{{ achievement.anotherContestName }}</span>
    <span v-else-if="header === 'achievement_status'"> {{ $t(`components.publication_element.statuses.${achievement.status}`) }}</span>
    <span v-else-if="header === 'achievement_status_pbn'"> {{ $t(`components.publication_element.statusesPolon.${achievement.statusPbn}`) }}</span>
    <span v-else-if="header === 'external_id'"> {{ aImport }}</span>
    <div v-else-if="header === 'fee_amount'">{{ achievement.feeAmount }}</div>
    <div v-else-if="header === 'fee_type'">
      <span v-if="achievement.feeAct">{{ $t('views.achievement.new.details.fee_act') }}</span>
      <span v-else-if="achievement.feeProject">{{ $t('views.achievement.new.details.fee_project') }}</span>
      <span v-else-if="achievement.feeOther">{{ $t('views.achievement.new.details.fee_other') }}</span>
      <span v-else-if="achievement.feeFree">{{ $t('views.achievement.new.details.fee_free') }}</span>
      <span v-else>{{ $t('general.not_applicable') }}</span>
    </div>
    <span v-else-if="header === 'conference'">
      <span v-if="achievement.publicationTypeId === 4 || achievement.publicationTypeId === 25 || achievement.conferenceMaterial">{{ conferenceMaterial }}</span>
    </span>
    <span v-else-if="header === 'contest_name'">{{ tableContestName }}</span>
    <div v-else-if="header === 'contributors'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor-${achievement.id}-${contributor.id}-${index}`">
              {{ contributor.name }}
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor-${achievement.id}-${contributor.id}-${index}`">
              {{ contributor.name }}
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor-${achievement.id}-${contributor.id}-${index}`">
          {{ contributor.name }}
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_employee_id'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_employee_id-${achievement.id}-${contributor.id}-${index}`">
              <span v-if="contributor.employeeId">{{ contributor.employeeId }}</span>
              <span v-else>{{ $t('general.lack') }}</span>
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_employee_id-${achievement.id}-${contributor.id}-${index}`">
              <span v-if="contributor.employeeId">{{ contributor.employeeId }}</span>
              <span v-else>{{ $t('general.lack') }}</span>
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_employee_id-${achievement.id}-${contributor.id}-${index}`">
          <span v-if="contributor.employeeId">{{ contributor.employeeId }}</span>
          <span v-else>{{ $t('general.lack') }}</span>
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_points'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_points-${achievement.id}-${contributor.id}-${index}`">
              <span v-if="contributor.alternativePoints">{{ contributor.alternativePoints }} ({{ contributor.epoints }})</span>
              <span v-else-if="contributor.epoints">{{ contributor.epoints }}</span>
              <span v-else>{{ $t('components.publication_table_element.no_points') }}</span>
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_points-${achievement.id}-${contributor.id}-${index}`">
              <span v-if="contributor.alternativePoints">{{ contributor.alternativePoints }} ({{ contributor.epoints }})</span>
              <span v-else-if="contributor.epoints">{{ contributor.epoints }}</span>
              <span v-else>{{ $t('components.publication_table_element.no_points') }}</span>
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_points-${achievement.id}-${contributor.id}-${index}`">
          <span v-if="contributor.alternativePoints">{{ contributor.alternativePoints }} ({{ contributor.epoints }})</span>
          <span v-else-if="contributor.epoints">{{ contributor.epoints }}</span>
          <span v-else>{{ $t('components.publication_table_element.no_points') }}</span>
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_part'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_part-${achievement.id}-${contributor.id}-${index}`">
              {{ contributor.part }}
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_part-${achievement.id}-${contributor.id}-${index}`">
              {{ contributor.part }}
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_part-${achievement.id}-${contributor.id}-${index}`">
          {{ contributor.part }}
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_discipline'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_discipline-${achievement.id}-${contributor.id}-${index}`">
              {{ contributorDisciplineName(contributor) }}
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_discipline-${achievement.id}-${contributor.id}-${index}`">
              {{ contributorDisciplineName(contributor) }}
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_discipline-${achievement.id}-${contributor.id}-${index}`">
          {{ contributorDisciplineName(contributor) }}
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_evaluation'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_evaluation-${achievement.id}-${contributor.id}-${index}`">
              <span v-if="contributor.submitted">{{ $t('views.orcid_publications.evaluation_agreement') }}</span>
              <span v-else>{{ $t('components.publication_table_element.no_evaluation') }}</span>
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_evaluation-${achievement.id}-${contributor.id}-${index}`">
              <span v-if="contributor.submitted">{{ $t('views.orcid_publications.evaluation_agreement') }}</span>
              <span v-else>{{ $t('components.publication_table_element.no_evaluation') }}</span>
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_evaluation-${achievement.id}-${contributor.id}-${index}`">
          <span v-if="contributor.submitted">{{ $t('views.orcid_publications.evaluation_agreement') }}</span>
          <span v-else>{{ $t('components.publication_table_element.no_evaluation') }}</span>
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_evaluation_date'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_evaluation_date-${achievement.id}-${contributor.id}-${index}`">
              <span v-if="contributor.submitted">
                <span v-if="contributor.submittedDate">{{ $d(Date.parse(contributor.submittedDate), 'short') }}</span>
                <span v-else>{{ $t('components.publication_table_element.no_evaluation_agreement_date') }}</span>
              </span>
              <span v-else>{{ $t('components.publication_table_element.not_apply') }}</span>
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_evaluation_date-${achievement.id}-${contributor.id}-${index}`">
              <span v-if="contributor.submitted">
                <span v-if="contributor.submittedDate">{{ $d(Date.parse(contributor.submittedDate), 'short') }}</span>
                <span v-else>{{ $t('components.publication_table_element.no_evaluation_agreement_date') }}</span>
              </span>
              <span v-else>{{ $t('components.publication_table_element.not_apply') }}</span>
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_evaluation_date-${achievement.id}-${contributor.id}-${index}`">
          <span v-if="contributor.submitted">
            <span v-if="contributor.submittedDate">{{ $d(Date.parse(contributor.submittedDate), 'short') }}</span>
            <span v-else>{{ $t('components.publication_table_element.no_evaluation_agreement_date') }}</span>
          </span>
          <span v-else>{{ $t('components.publication_table_element.not_apply') }}</span>
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_evaluation_algorithm'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_evaluation_algorithm-${achievement.id}-${contributor.id}-${index}`">
              <span v-if="contributor.evaluationAccepted">{{ $t('views.orcid_publications.evaluation_accepted') }}</span>
              <span v-else>{{ $t('views.orcid_publications.no_evaluation_accepted') }}</span>
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_evaluation_algorithm-${achievement.id}-${contributor.id}-${index}`">
              <span v-if="contributor.evaluationAccepted">{{ $t('views.orcid_publications.evaluation_accepted') }}</span>
              <span v-else>{{ $t('views.orcid_publications.no_evaluation_accepted') }}</span>
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_evaluation_algorithm-${achievement.id}-${contributor.id}-${index}`">
          <span v-if="contributor.evaluationAccepted">{{ $t('views.orcid_publications.evaluation_accepted') }}</span>
          <span v-else>{{ $t('views.orcid_publications.no_evaluation_accepted') }}</span>
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_faculty'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_faculty-${achievement.id}-${contributor.id}-${index}`">
              {{ contributorFacultyName(contributor) }}
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_faculty-${achievement.id}-${contributor.id}-${index}`">
              {{ contributorFacultyName(contributor) }}
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_faculty-${achievement.id}-${contributor.id}-${index}`">
          {{ contributorFacultyName(contributor) }}
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_doctoral_school'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_doctoral_school-${achievement.id}-${contributor.id}-${index}`">
              {{ contributorDoctoralSchool(contributor) }}
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_doctoral_school-${achievement.id}-${contributor.id}-${index}`">
              {{ contributorDoctoralSchool(contributor) }}
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_doctoral_school-${achievement.id}-${contributor.id}-${index}`">
          {{ contributorDoctoralSchool(contributor) }}
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_wrong_discipline_periodical'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_wrong-discipline_periodical-${achievement.id}-${contributor.id}-${index}`">
              <span>{{ hasWrongDisciplinePeriodical(contributor) }}</span>
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_wrong-discipline_periodical-${achievement.id}-${contributor.id}-${index}`">
              <span>{{ hasWrongDisciplinePeriodical(contributor) }}</span>
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_wrong-discipline_periodical-${achievement.id}-${contributor.id}-${index}`">
          <span>{{ hasWrongDisciplinePeriodical(contributor) }}</span>
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_wrong_discipline_statement'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_wrong-discipline_statement-${achievement.id}-${contributor.id}-${index}`">
              <span>{{ hasWrongDiscipline(contributor) }}</span>
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_wrong-discipline_statement-${achievement.id}-${contributor.id}-${index}`">
              <span>{{ hasWrongDiscipline(contributor) }}</span>
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_wrong-discipline_statement-${achievement.id}-${contributor.id}-${index}`">
          <span>{{ hasWrongDiscipline(contributor) }}</span>
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_wrong_discipline_statement_year'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_wrong-discipline_statement-year-${achievement.id}-${contributor.id}-${index}`">
              <span>{{ hasWrongDisciplineYear(contributor) }}</span>
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_wrong-discipline_statement-year-${achievement.id}-${contributor.id}-${index}`">
              <span>{{ hasWrongDisciplineYear(contributor) }}</span>
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_wrong-discipline_statement-year-${achievement.id}-${contributor.id}-${index}`">
          <span>{{ hasWrongDisciplineYear(contributor) }}</span>
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_wrong_n_statement'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_wrong-n_statement-${achievement.id}-${contributor.id}-${index}`">
              <span>{{ noNStatement(contributor) }}</span>
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_wrong-n_statement-${achievement.id}-${contributor.id}-${index}`">
              <span>{{ noNStatement(contributor) }}</span>
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_wrong-n_statement-${achievement.id}-${contributor.id}-${index}`">
          <span>{{ noNStatement(contributor) }}</span>
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_n_statement_last_year'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_n_statement_last_year-${achievement.id}-${contributor.id}-${index}`">
              <span>{{ noNStatementLastYear(contributor) }}</span>
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_n_statement_last_year-${achievement.id}-${contributor.id}-${index}`">
              <span>{{ noNStatementLastYear(contributor) }}</span>
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_n_statement_last_year-${achievement.id}-${contributor.id}-${index}`">
          <span>{{ noNStatementLastYear(contributor) }}</span>
        </div>
      </template>
    </div>
    <div v-else-if="header === 'ministerial_list'">
      <span v-if="achievement.inMenList">{{ $t('general.yes') }}</span>
      <span v-else>{{ $t('general.no') }}</span>
    </div>
    <div v-else-if="header === 'contributor_name_and_id'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_name_and_sap-${achievement.id}-${contributor.id}-${index}`">
              <span>{{ contributor.name }}</span>
              <span v-if="contributor.sourceId"> ({{ contributor.sourceId }})</span>
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_name_and_sap-${achievement.id}-${contributor.id}-${index}`">
              <span>{{ contributor.name }}</span>
              <span v-if="contributor.sourceId"> ({{ contributor.sourceId }})</span>
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_name_and_sap-${achievement.id}-${contributor.id}-${index}`">
          <span>{{ contributor.name }}</span>
          <span v-if="contributor.sourceId"> ({{ contributor.sourceId }})</span>
        </div>
      </template>
    </div>
    <div v-else-if="header === 'contributor_polon_uuid'">
      <template v-if="tooManyContributors">
        <transition name="fade" mode="out-in">
          <div v-if="showAll" key="1">
            <div v-for="(contributor, index) in allContributors" :key="`contributor_polon_uuid-${achievement.id}-${contributor.id}-${index}`">
              <span v-if="contributor.polonUuid">
                {{ contributor.polonUuid }}
              </span>
              <span v-else>
                {{ $t('general.lack') }}
              </span>
            </div>
          </div>
          <div v-if="!showAll" key="2">
            <div v-for="(contributor, index) in allContributors.slice(0, 5)" :key="`contributor_polon_uuid-${achievement.id}-${contributor.id}-${index}`">
              <span v-if="contributor.polonUuid">
                {{ contributor.polonUuid }}
              </span>
              <span v-else>
                {{ $t('general.lack') }}
              </span>
            </div>
          </div>
        </transition>
        <div class="my-hide" @click="changeShowAll()">
          <a v-if="showAll" href="javascript:;" :aria-label="$t('general.collapse')" :aria-expanded="!showAll.toString()">
            {{ $t('general.collapse') }}
            <i class="fas fa-angle-up"></i>
          </a>
          <a v-else href="javascript:;" :aria-label="$t('general.expand')" :aria-expanded="!showAll.toString()">
            {{ $t('general.expand') }}
            <i class="fas fa-angle-down"></i>
          </a>
        </div>
      </template>
      <template v-else>
        <div v-for="(contributor, index) in allContributors" :key="`contributor_polon_uuid-${achievement.id}-${contributor.id}-${index}`">
          <span v-if="contributor.polonUuid">
            {{ contributor.polonUuid }}
          </span>
          <span v-else>
            {{ $t('general.lack') }}
          </span>
        </div>
      </template>
    </div>
    <span v-else-if="header === 'country_amount'">{{ achievement.nationalFunds }}</span>
    <div v-else-if="header === 'created_at'">
      {{ $d(Date.parse(achievement.createdAt), 'long') }}
    </div>
    <div v-else-if="header === 'discipline'">
      <div v-for="discipline in achievementDisciplines" :key="`discipline-${achievement.id}-${discipline.id}`">
        {{ disciplineName(discipline.disciplineId) }}
      </div>
    </div>
    <span v-else-if="header === 'doi'">{{ isDoi }}</span>
    <span v-else-if="hasRight('view_publication_flags') && (header === 'flags')">{{ tableFlagNames }}</span>
    <span v-else-if="header === 'foreign_amount'">{{ achievement.foreignFunds }}</span>
    <span v-else-if="header === 'financing_institution_different_name'">{{ otherFinancingInstitutionNames }}</span>
    <span v-else-if="header === 'financing_institution_different'">{{ otherFinancingInstitutions }}</span>
    <span v-else-if="header === 'financing_source'">{{ financingSource }}</span>
    <span v-else-if="header === 'issn'">{{ isIssn }}</span>
    <span v-else-if="header === 'eissn'">{{ isEissn }}</span>
    <span v-else-if="header === 'isbn'">{{ isIsbn }}</span>
    <span v-else-if="header === 'periodical'">
      <span v-if="achievement.publicationTypeId === 20">{{ periodical }}</span>
    </span>
    <span v-else-if="header === 'highest_percentile'">
      <span v-if="achievement.publicationTypeId === 20">{{ achievement.publisher.percentile }}</span>
    </span>
    <span v-else-if="header === 'citations'">
      <span v-if="achievement.publicationTypeId === 20">{{ achievement.publisher.citations }}</span>
    </span>
    <span v-else-if="header === 'cite_score'">
      <span v-if="achievement.publicationTypeId === 20">{{ achievement.publisher.citeScore }}</span>
    </span>
    <span v-else-if="header === 'cited'">
      <span v-if="achievement.publicationTypeId === 20">{{ achievement.publisher.cited }}</span>
    </span>
    <span v-else-if="header === 'documents'">
      <span v-if="achievement.publicationTypeId === 20">{{ achievement.publisher.documents }}</span>
    </span>
    <span v-else-if="header === 'snip'">
      <span v-if="achievement.publicationTypeId === 20">{{ achievement.publisher.snip }}</span>
    </span>
    <span v-else-if="header === 'sjr'">
      <span v-if="achievement.publicationTypeId === 20">{{ achievement.publisher.sjr }}</span>
    </span>
    <div v-else-if="header === 'achievement_source'">
      <span v-if="achievement.mainSource">
        <span v-if="achievement.mainSource === 'orcid'">ORCiD</span>
        <span v-if="achievement.mainSource === 'pbn'">PBN</span>
        <span v-if="achievement.mainSource === 'polon'">POL-on</span>
        <span v-if="achievement.mainSource === 'self'">{{ $t('views.achievement.list.record') }}</span>
        <span v-if="achievement.mainSource === 'api'">API</span>
      </span>
      <span v-else>
        {{ $t('views.achievement.list.record') }}
      </span>
    </div>
    <div v-else-if="header === 'duplicates'">
      <div v-for="duplicate in achievement.duplicates" :key="duplicate.id">
        {{ $t('components.publication_table_element.duplicate_id') }} {{ duplicate.id }}
      </div>
    </div>
    <span v-else-if="header === 'principal_name'">{{ achievement.principalName }}</span>
    <div v-else-if="header === 'abstract'" style="max-width: 20rem; overflow-wrap: break-word; word-break: break-word; white-space: break-spaces;">
      {{ achievement.abstract ? achievement.abstract.substring(0,30) : ''}}
    </div>
    <div v-else-if="header === 'project_abstract_en'" style="max-width: 20rem; overflow-wrap: break-word; word-break: break-word; white-space: break-spaces;">
      {{ achievement.projectAbstractEn ? achievement.projectAbstractEn.substring(0,30) : '' }}
    </div>
    <span v-else-if="header === 'project_acronym'" class="long-text">{{ achievement.projectAcronym }}</span>
    <span v-else-if="header === 'project_end'">{{ achievement.projectEnd }}</span>
    <span v-else-if="header === 'project_individual'">{{ tf(achievement.projectIndividual) }}</span>
    <div v-else-if="header === 'project_manager'">
      <div v-for="manager in achievement.projectManagers" :key="`project_manager-${achievement.id}-${manager.id}`">
        {{ manager.author.name }}
      </div>
    </div>
    <div v-else-if="header === 'project_manager_polon_uuid'">
      <div v-for="manager in achievement.projectManagers" :key="`project_manager_polon_uuid-${achievement.id}-${manager.id}`">
        <span v-if="manager.author.polonUuid">
           {{ manager.author.polonUuid }}
        </span>
        <span v-else>
           {{ $t('general.lack') }}
        </span>
      </div>
    </div>
    <span v-else-if="header === 'project_number'">{{ achievement.projectNumber }}</span>
    <span v-else-if="header === 'project_participants'">{{ tableProjectParticipants }}</span>
    <span v-else-if="header === 'project_priority_name'">{{ achievement.projectPriorityName }}</span>
    <span v-else-if="header === 'project_start'">{{ achievement.projectStart }}</span>
    <span v-else-if="header === 'project_types'">{{ projectTypeNames }}</span>
    <span v-else-if="header === 'publisher'">
      <span v-if="achievement.publicationTypeId === 3 || achievement.publicationTypeId === 19 || achievement.publicationTypeId === 21">{{ periodical }}</span>
    </span>
    <div v-else-if="header === 'related_projects'">
      <div v-for="project in achievement.relatedProjects" :key="`related-project-${achievement.id}-${project.id}`">
        <span>{{ project.name }}</span>
      </div>
    </div>
    <span v-else-if="header === 'source_points'">{{ achievement.sourcePoints }}</span>
    <span v-else-if="header === 'total_amount'">{{ (achievement.publicationTypeId === 7 || achievement.publicationTypeId === 32) ? achievement.totalFunds : achievement.amount }}</span>
    <div v-else-if="header === 'updated_at'">
      {{ achievement.lastModifiedAt ? $d(Date.parse(achievement.lastModifiedAt), 'long') : $d(Date.parse(achievement.updatedAt), 'long') }}
    </div>
    <span v-else-if="header === 'external_link'" class="long-text">{{ achievement.externalLink }}</span>
    <span v-else-if="header === 'project_contest_edition'">{{ achievement.projectContestEdition }}</span>
    <span v-else-if="header === 'contract_date'" class="long-text">{{ projectContractDates }}</span>
    <span v-else-if="header === 'project_leader'">{{ achievement.projectLeader }}</span>
    <span v-else-if="header === 'entities_realizing_projects'" class="long-text">{{ entityRealizingProjects }}</span>
    <span v-else-if="header === 'entities_realizing_projects_leader'">{{ entityRealizingProjectsLeader }}</span>
    <span v-else-if="header === 'entities_realizing_projects_own_amount'">{{ entityRealizingProjectsOwnAmount }}</span>
    <span v-else-if="header === 'entities_realizing_projects_rp'">{{ entityRealizingProjectsRp }}</span>
    <span v-else-if="header === 'disseminating_science'">{{ tf(achievement.disseminatingScience) }}</span>
    <span v-else-if="header === 'financing_institution_kind'">{{ financingInstitutionsType }}</span>
    <span v-else-if="header === 'funded_competition_mode'">{{ tf(achievement.fundedCompetitionMode) }}</span>
    <span v-else-if="header === 'settlement_date'" class="long-text">{{ projectSettlementDates }}</span>
    <span v-else-if="header === 'export_error'" class="long-text">{{ achievement.exportError }}</span>
    <span v-else-if="header === 'keywords'" class="long-text">{{ achievement.keywordLabels }}</span>
    <span v-else-if="header === 'art_characteristic'" class="long-text">{{ achievement.artCharacteristic }}</span>
    <span v-else-if="header === 'language_abstracts'" class="long-text">{{ achievement.languageAbstracts }}</span>
    <span v-else-if="header === 'service_entity'" class="long-text">{{ achievement.serviceEntity }}</span>
    <span v-else-if="header === 'discipline_points'">{{ achievement.disciplinePoints }}</span>
    <span v-else-if="header === 'project_rejection_reason'">{{ projectRejectionReasons(achievement.projectRejectionReason) }}</span>
    <span v-else-if="header === 'patent_number'">{{ achievement.patentNumber }}</span>
    <span v-else-if="header === 'announcement_date' && achievement.publicationTypeId === 7">{{ achievement.publicationDate }}</span>
    <span v-else-if="header === 'decision_date'">{{ achievement.decisionDate }}</span>
    <span v-else-if="header === 'patent_application_number'">{{ achievement.patentApplicationNumber }}</span>
    <span v-else-if="header === 'entity_granting_patent'">{{ entityGrantingPatent(achievement.entityGrantingPatent) }}</span>
    <div v-else-if="header === 'periodical_disciplines'">
      <div v-for="discipline in achievement.allowedPeriodicalIds" :key="`periodical-discipline-${achievement.id}-${discipline}`">
        {{ disciplineName(discipline) }}
      </div>
    </div>
    <span v-else-if="header === 'art_evaluation'">{{ tf(achievement.artEvaluation) }}</span>
    <span v-else-if="header === 'issue'">{{ achievement.issue }}</span>
    <span v-else-if="header === 'issue_number'">{{ achievement.issueNumber }}</span>
    <span v-else-if="header === 'language'">
      <span v-if="$i18n.locale === 'pl'">{{ achievement.languageLabel }}</span>
      <span v-else>{{ achievement.languageLabelEn }}</span>
    </span>
    <span v-else-if="header === 'pages' && (achievement.publicationTypeId === 3 || achievement.publicationTypeId === 21)">{{ achievement.pages }}</span>
    <span v-else-if="header === 'pages_from_to' && (achievement.publicationTypeId === 19 || achievement.publicationTypeId === 20)">{{ achievement.pages }}</span>
    <span v-else-if="header === 'publication_place'">{{ achievement.publicationPlace }}</span>
    <span v-else-if="header === 'publishing_series'">{{ achievement.publishingSeriesName }}</span>
    <span v-else-if="header === 'publishing_series_number'">{{ achievement.publishingSeriesNumber }}</span>
    <span v-else-if="header === 'volume'">{{ achievement.volume }}</span>
    <span v-else-if="header === 'open_access'">{{ tf(achievement.openAccess) }}</span>
    <span v-else-if="header === 'licence'" class="long-text">{{ tableLicence }}</span>
    <span v-else-if="header === 'sharing_date'">{{ tableSharingDate }}</span>
    <span v-else-if="header === 'sharing_moment'">{{ tableSharingMoment }}</span>
    <span v-else-if="header === 'sharing_way'">{{ tableSharingWay }}</span>
    <span v-else-if="header === 'text_version'">{{ tableTextVersion }}</span>
    <span v-else-if="header === 'monograph_title'">{{ achievement.monographTitle }}</span>
    <span v-else-if="header === 'achievement_sub_type'">{{ subType(achievement.isCommercialization) }}</span>
    <span v-else-if="header === 'service_amount'">{{ achievement.amount }}</span>
    <span v-else-if="header === 'income_by_entity'">{{ tf(achievement.incomeByEntity) }}</span>
    <span v-else-if="header === 'art_discipline'">
      <span v-if="$i18n.locale === 'pl'">{{ achievement.artDisciplineLabel }}</span>
      <span v-else>{{ achievement.artDisciplineLabelEn }}</span>
    </span>
    <span v-else-if="header === 'art_kind'" class="long-text">{{ achievement.artKindLabel }}</span>
    <span v-else-if="header === 'art_type'">{{ achievement.artTypeLabel }}</span>
    <span v-else-if="header === 'art_importance'">{{ artImportance(achievement.artImportance) }}</span>
    <span v-else-if="header === 'year_first_public'">{{ achievement.yearFirstPublic }}</span>
    <span v-else-if="header === 'country_first_public'">
      <span v-if="$i18n.locale === 'pl'">{{ achievement.countryFirstPublic.value }}</span>
      <span v-else>{{ achievement.countryFirstPublic.valueEn }}</span>
    </span>
    <span v-else-if="header === 'implementation_year'">{{ achievement.implementationYear }}</span>
    <span v-else-if="header === 'implementation_country'">
      <span v-if="$i18n.locale === 'pl'">{{ achievement.implementationCountry.value }}</span>
      <span v-else>{{ achievement.implementationCountry.valueEn }}</span>
    </span>
    <span v-else-if="header === 'range'">
      <span v-if="$i18n.locale === 'pl'">{{ achievement.rangeLabel }}</span>
      <span v-else>{{ achievement.rangeLabelEn }}</span>
    </span>
    <span v-else-if="header === 'evaluation_order'">{{ achievement.evaluationOrder }}</span>
    <span v-else-if="header === 'social_importance'">
      <span v-if="$i18n.locale === 'pl'">{{ achievement.socialImportanceLabel }}</span>
      <span v-else>{{ achievement.socialImportanceLabelEn }}</span>
    </span>
    <span v-else-if="header === 'impact_notification_type'" class="long-text">
      <span v-if="$i18n.locale === 'pl'">{{ achievement.impactNotificationTypeLabel }}</span>
      <span v-else>{{ achievement.impactNotificationTypeLabelEn }}</span>
    </span>
    <span v-else-if="header === 'interdisciplinarity'">{{ tf(achievement.interdisciplinarity) }}</span>
    <span v-else-if="header === 'expert_points'">{{ achievement.expertPoints }}</span>
    <span v-else-if="header === 'patent_type'">{{ patentType(achievement.patentType) }}</span>
    <span v-else-if="header === 'other_entity'">{{ tf(achievement.otherEntity) }}</span>
    <span v-else-if="header === 'first_application'">{{ tf(achievement.firstApplication) }}</span>
    <span v-else-if="header === 'prior_priority_date'">{{ achievement.priorPriorityDate }}</span>
    <span v-else-if="header === 'priority_number'">{{ achievement.priorityNumber }}</span>
    <span v-else-if="header === 'prior_priority_country'">
      <span v-if="$i18n.locale === 'pl'">{{ achievement.priorPriorityCountryLabel }}</span>
      <span v-else>{{ achievement.priorPriorityCountryLabelEn }}</span>
    </span>
    <span v-else-if="header === 'exhibition_designation'">{{ achievement.exhibitionDesignation }}</span>
    <span v-else-if="header === 'patent_office'">{{ tf(achievement.patentOffice) }}</span>
    <span v-else-if="header === 'patent_application_number_in_uprp'">{{ achievement.patentApplicationNumberInUprp }}</span>
  </div>
</template>

<script>
import hasRight from '../mixins/has_right'
import { mapGetters } from 'vuex'
import ApiComments from '../api/comments'
import ApiPublications from '../api/publications'
import PublicationHistory from './PublicationHistory'
import unexpectedError from '../mixins/unexpected_error'
import tf from '../mixins/tf'
import projectRejectionReasons from '../mixins/project_rejection_reasons'

export default {
  name: 'PublicationTableElement',
  components: { PublicationHistory },
  mixins: [hasRight, tf, unexpectedError, projectRejectionReasons],
  props: {
    achievement: Object,
    contestOptions: Array,
    financingInstitutions: Array,
    financingSources: Array,
    flags: Array,
    projectTypes: Array,
    header: String,
    owner: {
      type: Boolean,
      default: false
    },
    multiCheckbox: {
      type: Boolean,
      default: false
    },
    multiSelect: String,
    unselectedPublications: Array,
    selectedPublications: Array,
    multiOperations: {
      type: Boolean,
      default: false
    },
    artImportances: Array,
    patentTypes: Array,
    entityGrantingPatents: Array,
    sharingWay: Array,
    sharingMoment: Array,
    textVersion: Array,
    licence: Array
  },
  data () {
    return {
      appKind: '',
      noRegister: 1,
      noRepo: 1,
      roles: [],
      currentUser: {
        id: '',
        author: '',
        entity: '',
        avatar: '',
        role: ''
      },
      pcgOptions: [],
      publicationCheckbox: false,
      allComments: [],
      history: null,
      allContributors: [],
      showAll: false,
      scope: 'basic',
      months: [
        { text: 'Styczeń', text_en: 'January', id: 'JANUARY' },
        { text: 'Luty', text_en: 'February', id: 'FEBRUARY' },
        { text: 'Marzec', text_en: 'March', id: 'MARCH' },
        { text: 'Kwiecień', text_en: 'April', id: 'APRIL' },
        { text: 'Maj', text_en: 'May', id: 'MAY' },
        { text: 'Czerwiec', text_en: 'June', id: 'JUNE' },
        { text: 'Lipiec', text_en: 'July', id: 'JULY' },
        { text: 'Sierpień', text_en: 'August', id: 'AUGUST' },
        { text: 'Wrzesień', text_en: 'September', id: 'SEPTEMBER' },
        { text: 'Październik', text_en: 'October', id: 'OCTOBER' },
        { text: 'Listopad', text_en: 'November', id: 'NOVEMBER' },
        { text: 'Grudzień', text_en: 'December', id: 'DECEMBER' }
      ]
    }
  },
  created () {
  },
  mounted () {
    this.setStatus()
    this.getAllContributors()
  },
  computed: {
    ...mapGetters('disciplines', ['disciplines']),
    achievement_title_en () {
      if (this.achievement.projectTitleEn) {
        return this.achievement.projectTitleEn
      } else {
        return this.achievement.otherTitles[0] ? this.achievement.otherTitles[0].value : ''
      }
    },
    achievementDisciplines () {
      if (this.achievement.projectDisciplines && this.achievement.projectDisciplines.length > 0) {
        return this.achievement.projectDisciplines
      } else if (this.achievement.serviceDisciplines && this.achievement.serviceDisciplines.length > 0) {
        return this.achievement.serviceDisciplines
      } else if (this.achievement.socialDisciplines && this.achievement.socialDisciplines.length > 0) {
        return this.achievement.socialDisciplines
      } else {
        return []
      }
    },
    publicationType () {
      const pubId = this.achievement.publicationTypeId
      let result = ''
      switch (pubId) {
        case 3:
          result = 'monograph'
          break
        case 4:
        case 25:
          result = 'conference'
          break
        case 7:
          result = 'patent'
          break
        case 19:
          result = 'chapter'
          break
        case 20:
          result = 'article'
          break
        case 21:
          result = 'monograph_redaction'
          break
        case 30:
          result = 'service'
          break
        case 32:
          result = 'project'
          break
        case 35:
          result = 'artistic_activity'
          break
        case 45:
          result = 'environmental_impact'
          break
        default:
          result = 'other'
      }
      return 'views.publications.types.' + result
    },
    isDoi () {
      if (this.achievement && this.achievement.sources && this.achievement.sources.length) {
        for (let i = 0; i < this.achievement.sources.length; i++) {
          if (this.achievement.sources[i].sourceName === 'doi') {
            return this.achievement.sources[i].sourceId
          }
        }
      }
      return null
    },
    isIsbn () {
      if (this.achievement && this.achievement.sources && this.achievement.sources.length) {
        for (let i = 0; i < this.achievement.sources.length; i++) {
          if (this.achievement.sources[i].sourceName === 'isbn') {
            return this.achievement.sources[i].sourceId
          }
        }
      }
      return null
    },
    isIssn () {
      if (this.achievement && this.achievement.sources && this.achievement.sources.length) {
        for (let i = 0; i < this.achievement.sources.length; i++) {
          if (this.achievement.sources[i].sourceName === 'issn') {
            return this.achievement.sources[i].sourceId
          }
        }
      }
      return null
    },
    isEissn () {
      if (this.achievement && this.achievement.sources && this.achievement.sources.length) {
        for (let i = 0; i < this.achievement.sources.length; i++) {
          if (this.achievement.sources[i].sourceName === 'eissn') {
            return this.achievement.sources[i].sourceId
          }
        }
      }
      return null
    },
    periodical () {
      let result = ''
      if (this.achievement.publisher.name) {
        result = this.achievement.publisher.name
      } else {
        result = this.achievement.publisherTitle || ''
      }
      return result
    },
    conferenceMaterial () {
      let result = ''
      result = this.achievement.publisherConference.name ? this.achievement.publisherConference.name : ''
      return result
    },
    otherFinancingInstitutions () {
      const result = []
      this.achievement.projectFinancings?.forEach((pf) => {
        if (pf.otherFinancingInstitution.value === null) {
          result.push('Nie')
        } else {
          result.push('Tak')
        }
      })
      return result.join(', ')
    },
    financingInstitutionsType () {
      const result = []
      this.achievement.projectFinancings?.forEach((pf) => {
        if (pf.kindOfFinancingInstitution === 'DOMESTIC') {
          result.push('krajowa')
        } else if (pf.kindOfFinancingInstitution === 'FOREIGN') {
          result.push('zagraniczna')
        } else if (pf.kindOfFinancingInstitution === 'INTERNATIONAL') {
          result.push('międzynarodowa')
        }
      })
      return result.join(', ')
    },
    otherFinancingInstitutionNames () {
      const result = []
      let fi = null
      this.achievement.projectFinancings?.forEach((pf) => {
        if (pf.otherFinancingInstitution.value === null) {
          fi = this.financingInstitutions.find((f) => {
            return f.id === pf.financingInstitution
          })
          result.push(pf.financingInstitutionDisplayName || fi.text)
        } else {
          result.push(pf.otherFinancingInstitution.value)
        }
      })
      return result.join(', ')
    },
    financingSource () {
      const result = []
      let fi = null
      this.achievement.projectFinancings?.forEach((pf) => {
        if (pf.otherFinancingSource.value === null) {
          fi = this.financingSources.find((f) => {
            return f.id === pf.financingSource
          })
          result.push(fi.text)
        } else {
          result.push(pf.otherFinancingSource.value)
        }
      })
      return result.join(', ')
    },
    tableContestName () {
      const found = this.contestOptions.find(element => element.id === this.achievement.contestName)
      if (found) {
        return found.text
      } else {
        return ''
      }
    },
    tableSharingWay () {
      const found = this.sharingWay.find(element => element.id === this.achievement.sharingWay)
      if (found) {
        return found.text
      } else {
        return ''
      }
    },
    tableSharingMoment () {
      const found = this.sharingMoment.find(element => element.id === this.achievement.sharingMoment)
      if (found) {
        return found.text
      } else {
        return ''
      }
    },
    tableTextVersion () {
      const found = this.textVersion.find(element => element.id === this.achievement.textVersion)
      if (found) {
        return found.text
      } else {
        return ''
      }
    },
    tableLicence () {
      const found = this.licence.find(element => element.id === this.achievement.licence)
      if (found) {
        return found.text
      } else {
        return ''
      }
    },
    tableSharingDate () {
      if (this.achievement.sharingDate) {
        return this.achievement.sharingDate
      } else if (this.achievement.sharingDateMonth && this.achievement.sharingDateYear) {
        let text = ''
        const found = this.months.find(element => element.id === this.achievement.sharingDateMonth)
        if (found) {
          text = found.text
        }
        return `${text} ${this.achievement.sharingDateYear}`
      }
    },
    tableFlagNames () {
      const result = []
      this.achievement.flags.forEach((flagId) => {
        const found = this.flags.find(element => element.id === flagId)
        if (found) {
          result.push(found.text)
        }
      })
      return result.join(', ')
    },
    projectTypeNames () {
      const result = []
      if (this.achievement.projectTypes) {
        this.achievement.projectTypes.forEach((ptId) => {
          const found = this.projectTypes.find(element => element.id === ptId)
          if (found) {
            result.push(found.text)
          }
        })
      }
      return result.join(', ')
    },
    tableProjectParticipants () {
      const result = []
      if (this.achievement.projectParticipants) {
        this.achievement.projectParticipants.forEach((pt) => {
          result.push(pt.author.name)
        })
      }
      return result.join(', ')
    },
    projectContractDates () {
      const result = []
      let fi = null
      this.achievement.projectFinancings?.forEach((pf) => {
        if (pf.otherFinancingInstitution.value === null) {
          fi = this.financingInstitutions.find((f) => {
            return f.id === pf.financingInstitution
          })
          result.push(`${pf.financingInstitutionDisplayName || fi.text} - ${pf.grantDate}`)
        } else {
          result.push(`${pf.otherFinancingInstitution.value} - ${pf.grantDate}`)
        }
      })
      return result.join('; ')
    },
    projectSettlementDates () {
      const result = []
      let fi = null
      this.achievement.projectFinancings?.forEach((pf) => {
        if (pf.otherFinancingInstitution.value === null) {
          fi = this.financingInstitutions.find((f) => {
            return f.id === pf.financingInstitution
          })
          result.push(`${pf.financingInstitutionDisplayName || fi.text} - ${pf.settlementDate}`)
        } else {
          result.push(`${pf.otherFinancingInstitution.value} - ${pf.settlementDate}`)
        }
      })
      return result.join('; ')
    },
    entityRealizingProjects () {
      const result = []
      this.achievement.projectImplementings?.forEach((pi) => {
        result.push(pi.entityProject.value)
      })
      return result.join('; ')
    },
    entityRealizingProjectsLeader () {
      const result = []
      this.achievement.projectImplementings?.forEach((pi) => {
        if (pi.leader) {
          result.push('tak')
        } else {
          result.push('nie')
        }
      })
      return result.join('; ')
    },
    entityRealizingProjectsOwnAmount () {
      const result = []
      this.achievement.projectImplementings?.forEach((pi) => {
        result.push(pi.ownFunds)
      })
      return result.join('; ')
    },
    entityRealizingProjectsRp () {
      const result = []
      this.achievement.projectImplementings?.forEach((pi) => {
        if (pi.inTerritory) {
          result.push('tak')
        } else {
          result.push('nie')
        }
      })
      return result.join('; ')
    },
    tooManyContributors () {
      if (this.allContributors && this.allContributors.length > 5) {
        return true
      } else {
        return false
      }
    },
    aImport: {
      get () {
        let source
        if (this.achievement && this.achievement.sources && this.achievement.sources.length) {
          source = this.achievement.sources.find(s => s.sourceName === 'api')
          if (source) {
            return source.sourceId
          } else {
            return null
          }
        }
        return null
      }
    }
  },
  beforeMount () {
    this.roles = this.$store.getters['auth/roles']
    this.currentUser = {
      id: this.$store.getters['auth/id'],
      author: this.$store.getters['auth/fullName'],
      entity: '',
      avatar: this.$store.getters['auth/avatar'],
      role: this.$store.getters['auth/currentRole']
    }
    this.appKind = process.env.APP_KIND
    this.noRegister = process.env.NO_REGISTER
    this.noRepo = process.env.NO_REPO
    // eslint-disable-next-line eqeqeq
    if (this.noRegister == 0) {
      if (this.hasRight('edit_achievement') || (this.owner && this.hasRight('edit_own_achievement'))) {
        this.pcgOptions.push({
          text: 'Edytuj',
          action: () => { this.editPublication() }
        })
      }
      if (this.hasRight('view_comments')) {
        this.pcgOptions.push({
          text: 'Komentarze',
          action: () => { this.showComments() }
        })
      }
      if (this.hasRight('view_history')) {
        this.pcgOptions.push({
          text: 'Historia publikacji',
          action: () => {
            this.getHistory('basic')
          }
        })
      }
      if ((this.currentUser.role === 'pracownik' || this.currentUser.role === 'analityknaukowy') && this.achievement.status !== 6) {
        this.pcgOptions.push({
          text: 'Archiwizuj',
          action: () => { this.archivePublicationsModal() }
        })
      }
      if ((this.currentUser.role === 'pracownik' || this.currentUser.role === 'analityknaukowy') && this.achievement.status === 6) {
        this.pcgOptions.push({
          text: 'Przywróć',
          action: () => { this.restorePublicationsModal() }
        })
      }
    }
  },
  methods: {
    editPublication () {
      this.$router.push({ name: 'achievement_edit_path', params: { id: this.achievement.id } })
    },
    showComments () {
      ApiComments.getComments(this.achievement.id)
        .then(result => {
          this.allComments = result.data.datas
          this.allComments.forEach(comment => {
            if (comment.date === comment.editedDate) {
              comment.editedDate = null
            }
            comment.date = this.$d(Date.parse(comment.date), 'long')
            comment.editedDate = comment.editedDate ? this.$d(Date.parse(comment.editedDate), 'long') : null
          })
          this.$bvModal.show(this.achievement.id + '-allCommentsModal')
        })
        .catch(error => {
          console.log(error)
        })
    },
    commentAdded (comment) {
      ApiComments.createComment(this.achievement.id, comment)
        .then(result => {
          ApiComments.getComments(this.achievement.id)
            .then(result => {
              this.allComments = result.data.datas
              this.allComments.forEach(comment => {
                if (comment.date === comment.editedDate) {
                  comment.editedDate = null
                }
                comment.date = this.$d(Date.parse(comment.date), 'long')
                comment.editedDate = comment.editedDate ? this.$d(Date.parse(comment.editedDate), 'long') : null
              })
              this.$bvModal.show(this.achievement.id + '-allCommentsModal')
            })
        })
        .catch(error => {
          console.log(error)
        })
    },
    getHistory (scope) {
      this.history = null
      this.scope = scope
      ApiPublications.getHistory(this.achievement.id, scope)
        .then(result => {
          this.history = result.data.datas
          this.$bvModal.show(this.achievement.id + '-historyModal')
        })
        .catch(error => {
          console.log(error)
        })
    },
    closeHistory () {
      this.$bvModal.hide(this.achievement.id + '-historyModal')
    },
    archivePublication () {
      ApiPublications.archivePublications([this.achievement.id], [])
        .then(result => {
          this.$emit('changePublicationStatus')
        })
        .catch(error => {
          console.log(error)
          this.unexpectedError()
        })
    },
    restorePublication () {
      ApiPublications.changeStatus(this.achievement.id, 0)
        .then(result => {
          this.$emit('changePublicationStatus')
        })
        .catch(error => {
          console.log(error)
          this.unexpectedError()
        })
    },
    archivePublicationsModal () {
      this.$refs.archivePublicationConfirm.show()
    },
    restorePublicationsModal () {
      this.$refs.restorePublicationConfirm.show()
    },
    changeStatus () {
      if (this.publicationCheckbox) {
        this.$emit('removeUnselected', this.achievement.id)
      } else {
        this.$emit('addUnselected', this.achievement.id)
      }
    },
    setStatus () {
      if (this.multiCheckbox && this.multiSelect) {
        this.publicationCheckbox = true
      } else if (!this.multiCheckbox) {
        this.publicationCheckbox = false
      }
      if (this.unselectedPublications && this.unselectedPublications.includes(this.achievement.id)) {
        this.publicationCheckbox = false
      }
      if (this.selectedPublications && this.selectedPublications.includes(this.achievement.id)) {
        this.publicationCheckbox = true
      }
    },
    contributorDisciplineName (author) {
      if (!author.disciplineId) {
        return this.$t('components.publication_table_element.no_discipline')
      }
      const idx = this.disciplines.findIndex(b => b.id === author.disciplineId.toString())
      if (idx >= 0) {
        if (this.$i18n.locale === 'pl') {
          return this.disciplines[idx].text
        } else {
          return this.disciplines[idx].text_en
        }
      } else {
        return this.$t('components.publication_table_element.no_discipline')
      }
    },
    contributorFacultyName (author) {
      if (!author.faculties || (author.faculties && author.faculties.length === 0)) {
        return this.$t('components.publication_table_element.no_faculties')
      }
      let facultyText = ''
      author.faculties.forEach(faculty => {
        if (facultyText) {
          facultyText = facultyText + ', ' + faculty.parents + ' -> ' + faculty.name
        } else {
          facultyText = faculty.parents + ' -> ' + faculty.name
        }
      })
      return facultyText
    },
    contributorDoctoralSchool (author) {
      if (!author.doctoralSchoolCode && author.authorType !== 3) {
        return this.$t('components.publication_table_element.no_doctoral_school_code_required')
      } else if (!author.doctoralSchoolCode && author.authorType === 3) {
        return this.$t('components.publication_table_element.no_doctoral_school_code')
      } else
        return author.doctoralSchoolCode
    },
    disciplineName (id) {
      if (!id) {
        return this.$t('components.publication_table_element.no_discipline')
      }
      const idx = this.disciplines.findIndex(b => b.id === id.toString())
      if (idx >= 0) {
        if (this.$i18n.locale === 'pl') {
          return this.disciplines[idx].text
        } else {
          return this.disciplines[idx].text_en
        }
      } else {
        return this.$t('components.publication_table_element.no_discipline')
      }
    },
    subType (value) {
      if (value) {
        return 'Komercjalizacja wyników badań'
      } else {
        return 'Usługi badawcze'
      }
    },
    artImportance (id) {
      if (!id) {
        return ''
      }
      const idx = this.artImportances.findIndex(b => b.id === id.toString())
      if (idx >= 0) {
        if (this.$i18n.locale === 'pl') {
          return this.artImportances[idx].text
        } else {
          return this.artImportances[idx].text_en
        }
      } else {
        return ''
      }
    },
    patentType (id) {
      if (!id) {
        return ''
      }
      const idx = this.patentTypes.findIndex(b => b.id === id.toString())
      if (idx >= 0) {
        if (this.$i18n.locale === 'pl') {
          return this.patentTypes[idx].text
        } else {
          return this.patentTypes[idx].text_en
        }
      } else {
        return ''
      }
    },
    entityGrantingPatent (id) {
      if (!id) {
        return ''
      }
      const idx = this.entityGrantingPatents.findIndex(b => b.id === id.toString())
      if (idx >= 0) {
        if (this.$i18n.locale === 'pl') {
          return this.entityGrantingPatents[idx].text
        } else {
          return this.entityGrantingPatents[idx].text_en
        }
      } else {
        return ''
      }
    },
    getAllContributors () {
      this.allContributors = []
      this.achievement.authors.forEach((a) => {
        this.allContributors.push(a)
      })
      this.achievement.redactors.forEach((r) => {
        this.allContributors.push(r)
      })
    },
    changeShowAll () {
      this.showAll = !this.showAll
    },
    hasWrongDisciplinePeriodical (author) {
      let text = ''
      if (this.achievement.publicationTypeId === 20) {
        if (author.disciplineId && (!this.achievement.allowedPeriodicalIds || this.achievement.allowedPeriodicalIds && this.achievement.allowedPeriodicalIds.includes(author.disciplineId))) {
          text = this.$t('general.yes')
        } else {
          if (!author.disciplineId) {
            text = this.$t('components.publication_table_element.no_discipline')
          } else {
            text = this.$t('general.no')
          }
        }
      }
      return text
    },
    hasWrongDiscipline (author) {
      let text = ''
      let filteredDisciplines = []
      if (author.disciplineId) {
        filteredDisciplines = author.disciplines.filter(discipline => discipline.id === author.disciplineId)
      }
      if (filteredDisciplines.length > 0) {
        text = this.$t('general.yes')
      } else {
        if (!author.disciplineId) {
          text = this.$t('components.publication_table_element.no_discipline')
        } else {
          text = this.$t('general.no')
        }
      }
      return text
    },
    hasWrongDisciplineYear (author) {
      let text = ''
      if (author.disciplinePublicationYear) {
        text = this.$t('general.yes')
      } else {
        text = this.$t('general.no')
      }
      return text
    },
    noNStatement (author) {
      let text = ''
      if (author.authorType === 0) {
        if (author.ndisciplines) {
          text = this.$t('general.yes')
        } else {
          text = this.$t('general.no')
        }
      } else {
        if (author.authorType === 3) {
          text = this.$t('general.not_applicable')
        } else {
          text = this.$t('components.publication_table_element.no_discipline')
        }
      }
      return text
    },
    noNStatementLastYear (author) {
      let text = ''
      if (author.authorType === 0) {
        if (author.ndisciplineLastYear) {
          text = this.$t('general.yes')
        } else {
          text = this.$t('general.no')
        }
      } else {
        if (author.authorType === 3) {
          text = this.$t('general.not_applicable')
        } else {
          text = this.$t('components.publication_table_element.no_discipline')
        }
      }
      return text
    }
  },
  watch: {
    multiSelect: {
      deep: true,
      handler () {
        this.setStatus()
      }
    },
    multiCheckbox: {
      deep: true,
      handler () {
        this.setStatus()
      }
    },
    'achievement.authors': {
      deep: true,
      handler () {
        this.getAllContributors()
      }
    },
    'achievement.redactors': {
      deep: true,
      handler () {
        this.getAllContributors()
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '../assets/stylesheets/vars';
  .multi-checkboxes {
    display: inline-block;
    /deep/ .pcg-checkbox-container {
      margin-bottom: 0;
      margin-right: 0;
    }
  }
  .action-btn {
    height: 35px;
  }
  .confirm-header {
    font-size: $font-size-m;
    font-weight: 400;
    color: $pcg-gray;
    margin-bottom: 1.5rem;
  }
  .confirm-text {
    font-weight: 400;
    color: $pcg-gray;
    margin-bottom: 1rem;
  }
  .my-hide {
    color: $main-color;
    cursor: pointer;
    a {
      color: unset;
      text-decoration: none;
      &:hover {
        color: unset;
        text-decoration: none;
      }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  .long-text {
    display: inline-block;
    min-width: 300px;
    max-width: 400px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }
</style>

<style lang="scss" >
  @import "../assets/stylesheets/vars-contrast";
  .contrast {
    .confirm-header {
      color: $pcg-gray;
    }
    .confirm-text {
      color: $pcg-gray;
    }
    .action-btn {
      /deep/ .pcg-button {
        background: $pcg-the-lightest-gray !important;
        g {
          fill: rgb(0, 153, 65) !important;
        }
      }
    }
    .my-hide {
      color: $main-color;
    }
  }
</style>
